import { registerPlugin } from '@capacitor/core';

import type { ZenTrainsPushPlugin } from './definitions';

const ZenTrainsPush = registerPlugin<ZenTrainsPushPlugin>('ZenTrainsPushPlugin', {});

export * from './definitions';
export { ZenTrainsPush };
